module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAACCAYAAAAaRY8cAAAAGElEQVQYlWP8////f4ZhAJiGgycYGBgYADzSBAAcswcuAAAAAElFTkSuQmCC"